import { navigateWithReload } from '../../../../../src/app/shared/utils/navigate-force-reload';

class UserDropdown {
  [x: string]: any;

  static $inject = ['AccountsService', 'AuthService', 'ContactsListService', 'Router'];

  constructor(AccountsService, AuthService, ContactsListService, Router) {
    this.AccountsService = AccountsService;
    this.AuthService = AuthService;
    this.ContactsService = ContactsListService;
    this.router = Router;
  }

  isAccountsHide() {
    return this.AccountsService.getAccountsLength() === 1;
  }

  getUsername() {
    return this.AuthService.getUsername();
  }

  clearStorage() {
    this.ContactsService.resetState();
  }

  isChannelsClientType() {
    return this.AuthService.isChannelsClientType();
  }

  goToRoute(url) {
    this.router.navigateByUrl(url);
  }

  chooseAccount() {
    this.clearStorage();
    navigateWithReload(this.router, 'accounts')
  }

}

export default {
  controller: UserDropdown,
  transclude: true,
  template: require('./user.dropdown.html')
};
